import { Directive, EventEmitter, HostListener, Output } from '@angular/core';
import { get } from 'lodash';
import { MousePosition } from '@app/shared/models/mouse.model';

@Directive({
    selector: '[appMouseEvents]',
    standalone: false,
})
export class MouseEventsDirective {
    @Output() mouseMove: EventEmitter<MousePosition> = new EventEmitter<MousePosition>();
    @Output() mouseLeave: EventEmitter<void> = new EventEmitter<void>();

    @HostListener('mousemove', ['$event']) public onMouseMove(event: MouseEvent) {
        const x = get(event, 'chartX', 'clientX');
        const y = get(event, 'chartY', 'clientY');

        this.mouseMove.emit({
            x: Number(x),
            y: Number(y),
        });
    }

    @HostListener('mouseleave', ['$event']) public onMouseLeave() {
        this.mouseLeave.emit();
    }
}
